// What the organization's library holds: bytes, assets and media time, one entry per kind of asset.
// Every live asset counted once, whatever shelves hold it; the trash, folders and placeholders are
// not counted. Read by any member.

import { api } from '../client'
import type { components } from '../schema'

export type StorageUsageView = components['schemas']['StorageUsageView']
export type StorageUsageEntry = components['schemas']['StorageUsageEntry']

/** The organization's storage usage. A kind it holds nothing of is absent from `types`. */
export function getStorageUsage(signal?: AbortSignal): Promise<StorageUsageView> {
  return api.get<StorageUsageView>('/orgs/current/storage-usage', undefined, signal)
}
